// src/components/Tabs.js
import React, { useState, useEffect, useRef, useCallback } from 'react';
import './Tabs.css';

const Tabs = ({ tabsConfig, activeTab, onTabClick, tabErrors = {} }) => {
  const tabListRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const checkForScroll = useCallback(() => {
    const el = tabListRef.current;
    if (el) {
      const hasOverflow = el.scrollWidth > el.clientWidth;
      setShowLeftArrow(hasOverflow && el.scrollLeft > 5); // Show if scrolled more than 5px
      setShowRightArrow(hasOverflow && el.scrollLeft < el.scrollWidth - el.clientWidth - 5); // Show if there's more than 5px to scroll
    }
  }, []);

  useEffect(() => {
    const tabListEl = tabListRef.current;
    if (tabListEl) {
      // A slight delay for initial check to allow rendering
      const timer = setTimeout(checkForScroll, 100);

      tabListEl.addEventListener('scroll', checkForScroll);
      window.addEventListener('resize', checkForScroll);

      return () => {
        clearTimeout(timer);
        tabListEl.removeEventListener('scroll', checkForScroll);
        window.removeEventListener('resize', checkForScroll);
      };
    }
  }, [tabsConfig, checkForScroll]);

  const handleScroll = (direction) => {
    const el = tabListRef.current;
    if (el) {
      const scrollAmount = direction === 'left' ? -el.clientWidth / 2 : el.clientWidth / 2;
      el.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <div className="tabs-container">
      <div className="tabs-wrapper">
        {showLeftArrow && (
          <button className="scroll-arrow left" onClick={() => handleScroll('left')} type="button">
            ‹
          </button>
        )}
        <div className="tab-list" ref={tabListRef}>
          {tabsConfig.map((tab) => (
            <button
              key={tab.id}
              className={`tab-item ${activeTab === tab.id ? 'active' : ''} ${tabErrors[tab.id] && Object.keys(tabErrors[tab.id]).length > 0 ? 'has-errors' : ''}`}
              onClick={() => onTabClick(tab.id)}
              type="button" // Important to prevent form submission
            >
              {tab.label}
              {tabErrors[tab.id] && Object.keys(tabErrors[tab.id]).length > 0 && <span className="error-indicator">*</span>}
            </button>
          ))}
        </div>
        {showRightArrow && (
          <button className="scroll-arrow right" onClick={() => handleScroll('right')} type="button">
            ›
          </button>
        )}
      </div>
      <div className="tab-content">{/* Content will be rendered by the parent based on activeTab */}</div>
    </div>
  );
};

export default Tabs;
